export const storeFileUploadJsonSchema = {
  type: "object",
  properties: {
    storeFileData: {
      type: "array",
      items: { type: "object" },
      title: "",
      minItems: 1,
    },
  },
  required: ["storeFileData"],
};

export const storeFileUploadUISchema = {
  type: "VerticalLayout",
  elements: [
    {
      type: "Control",
      scope: "#/properties/storeFileData",
      component: "partnerFileUpload",
      accept: ".csv",
      isPartnerRequired: false,
      description: "Select a comma-separated CSV file with store data",
    },
  ],
};
